import { useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { RoutesConstants } from "@/main/routes/routesConstants";
import { getTranslateByKey } from "@/main/services/utils";

export interface ISearchOrderRedirectFilters {
	quoteFilterVehicle: string;
	startDate?: string;
	finalDate?: string;
}

export function buildSearchOrderRoute(filters: ISearchOrderRedirectFilters) {
	const params = new URLSearchParams();

	Object.entries(filters).forEach(([key, value]) => {
		if (value) params.append(key, value);
	});

	const query = params.toString();
	return query ? `${RoutesConstants.orderSearchOrder}?${query}` : RoutesConstants.orderSearchOrder;
}

function useStripeCheckoutRedirect(filters: ISearchOrderRedirectFilters) {
	const navigate = useNavigate();
	const hasRedirected = useRef<boolean>(false);
	const searchOrderRoute = buildSearchOrderRoute(filters);

	return useCallback(() => {
		if (hasRedirected.current) return;
		hasRedirected.current = true;

		toast.success(getTranslateByKey("information.paymentSucceededStripe"));

		navigate(searchOrderRoute);
	}, [searchOrderRoute]);
}

export default useStripeCheckoutRedirect;
